import { useEffect } from 'react'
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { FormBuilder } from '@/features/forms/builder/form-builder'

export const Route = createFileRoute(
  '/_authenticated/_organization/forms/$formId/edit'
)({
  component: FormBuilderPage,
})

function FormBuilderPage() {
  const { formId } = useParams({ strict: false }) as { formId: string }
  const navigate = useNavigate()
  const { data: activeOrganization, isPending: isLoadingOrganization } =
    authClient.useActiveOrganization()

  useEffect(() => {
    if (!isLoadingOrganization && !activeOrganization) {
      navigate({
        to: '/errors/$error',
        params: { error: 'forbidden' },
        state: {
          message:
            'No organization found. Please create an organization first and wait for approval.',
        } as any,
        replace: true,
      })
    }
  }, [isLoadingOrganization, activeOrganization, navigate])

  if (!activeOrganization) {
    return null
  }

  // `key` forces a remount when the route param changes. The builder holds ~18
  // pieces of local state (selected field/page/section ids, panel modes, dialog
  // flags, undo/redo history) and resets none of them on a `formId` change, so
  // a builder→builder navigation would otherwise carry the previous form's
  // selection into the new one — e.g. the properties panel bound to a field id
  // that doesn't exist here.
  return (
    <FormBuilder
      key={formId}
      formId={formId}
      organizationId={activeOrganization.id}
    />
  )
}
